import React from 'react';
import { Link } from "react-router-dom";


function BlogPostCard({ post }) {
    return (
        <li>
            <div className="recent-post-card">
                <figure className="card-banner img-holder" style={{ "--width": "271", "--height": "258" }}>
                    <img src={post.image} width={271} height={258} loading="lazy" alt={post.title} className="img-cover" />
                </figure>
                <div className="card-content">
                    <h3 className="headline headline-3 card-title">
                        <Link to={post.href} className="link hover-2">{post.title}</Link>
                    </h3>
                    <p className="card-text">{post.content}</p>
                    <div className="card-wrapper">
                        <div className="card-tag">
                            {post.tags.map((tag, index) => (
                                <Link to="#" key={index} className="span hover-2">{tag}</Link>
                            ))}
                        </div>
                        <div className="wrapper">
                            <ion-icon name="time-outline" aria-hidden="true" />
                            <span className="span">{post.timeRead}</span>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    );
}

export default BlogPostCard;